var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModeStreaks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_SuccessfulTrades"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1567_10346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1567_10346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "auto_fix_normal",
    d: "M13.8334 4.6665L13.2 3.29984L11.8334 2.6665L13.2 2.03317L13.8334 0.666504L14.4667 2.03317L15.8334 2.6665L14.4667 3.29984L13.8334 4.6665ZM3.90004 14.4665L2.03337 12.5998C1.90004 12.4665 1.83337 12.3054 1.83337 12.1165C1.83337 11.9276 1.90004 11.7665 2.03337 11.6332L9.46671 4.19984C9.60004 4.0665 9.76115 3.99984 9.95004 3.99984C10.1389 3.99984 10.3 4.0665 10.4334 4.19984L12.3 6.0665C12.4334 6.19984 12.5 6.36095 12.5 6.54984C12.5 6.73873 12.4334 6.89984 12.3 7.03317L4.86671 14.4665C4.73337 14.5998 4.57226 14.6665 4.38337 14.6665C4.19449 14.6665 4.03337 14.5998 3.90004 14.4665ZM9.95004 7.48317L10.8834 6.54984L9.95004 5.6165L9.01671 6.54984L9.95004 7.48317Z",
    fill: "#C4B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeStreaks);
export default __webpack_public_path__ + "static/media/mode_streaks.dd832241e2b3bdd495041078af9ae37a.svg";
export { ForwardRef as ReactComponent };